import { GcpBox, GcpTypography } from '@back-office/ui';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert from '@material-ui/lab/Alert';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FILE_SIZE_LIMIT } from '../../../constants';
import FileProcessingModal from '../FileProcessingModal';
import useViewModel from './viewmodel';

const useStyles = makeStyles(() => ({
  dragAndDrop: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px dashed #BDBDBD',
    borderRadius: '10px',
    height: '104px',
    boxShadow: 'none',
    textAlign: 'center',
    width: '100%',
    background: 'transparent',
    fontSize: '1rem',
  },
  button: {
    boxShadow: 'none',
    marginLeft: '16px',
    border: '1px solid #BDBDBD',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  alert: {
    justifyContent: 'center',
    margin: '16px 0',
  },
}));

export interface UploadOptions {
  scheduleDate: string;
  isProcessingNow: boolean;
}

export interface DragAndDropProps {
  onUpload: (file: File | undefined, options: UploadOptions) => void;
}

const DragAndDrop: FC<DragAndDropProps> = (props) => {
  const { onUpload } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    handleOnConfirm,
    isDragging,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    handleBrowseFile,
    on,
    toggle,
    alertMessage,
  } = useViewModel({
    onUpload,
  });

  return (
    <GcpBox mt={3}>
      {alertMessage && (
        <Alert className={classes.alert} icon={false} severity="error">
          <GcpTypography variant="body1">{alertMessage}</GcpTypography>
        </Alert>
      )}
      <button
        className={classes.dragAndDrop}
        type="button"
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragEnter}
        onDrop={handleDrop}
      >
        {t('payment_file.drop_file', { fileSizeLimit: FILE_SIZE_LIMIT })}
        <Button
          className={classes.button}
          component="label"
          style={{ backgroundColor: isDragging ? 'lightgray' : 'white' }}
          variant="contained"
        >
          Browse{' '}
          <input
            hidden
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            type="file"
            onInput={handleBrowseFile}
          />
        </Button>
      </button>
      <FileProcessingModal
        handleOnClose={() => toggle(false)}
        handleOnConfirm={handleOnConfirm}
        open={on}
      />
    </GcpBox>
  );
};

export default DragAndDrop;
